
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "ember-cache-primitive-polyfill/-embroider-implicit-modules.js";
